import {VeboxModels} from "../types/veboxModels";

/**
 * The new username must begin with a letter, be at least 5 characters long and contain only alphanumeric characters or one of these: '.', '_', '-', '@'. Spaces are not allowed
 * @param username
 */
export const isValidUsername = (username: string) => {
    return /^(?!U#[0-9]*$)[a-zA-Z][\w\-.@]{5,254}$/.test(username);
}

export const isMissingValues = (user: VeboxModels.User) => {
    return !user.name || !user.surname
}

/**
 * The password must be at least 6 char long, and it must contain: a lowercase/uppercase letter, a digit. Whitespaces are not allowed
 * @param password
 */
export const isValidPassword = (password: string): boolean => {
    return /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])(?!.*\s).{6,}$/.test(password)
}


export function isValidEmailAddress(emailStr: string) {
    return emailStr?.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/) !== null
}